import React from 'react';
import { useTranslation } from 'react-i18next';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Skeleton } from 'primereact/skeleton';
import { commonBodyStyle, commonHeaderStyle } from '../../interface/styles';

interface TableSkeletonLoaderProps {
  rows?: number;
  columns?: Array<{ header: string | React.ReactNode }>;
  actions?: boolean;
  rowHeight?: number;
}

const TableSkeletonLoader: React.FC<TableSkeletonLoaderProps> = ({
  rows = 5,
  columns = [],
  actions = false,
  rowHeight = 32,
}) => {
  const { t } = useTranslation();
  const dummyData = Array.from({ length: rows });
  const skeletonBody = () => <Skeleton height={`${rowHeight}px`} />;

  return (
    <DataTable value={dummyData} className="p-datatable-striped">
      {columns.map((col, i) => (
        <Column
          key={`skel-col-${i}`}
          header={col.header}
          body={skeletonBody}
          bodyStyle={{ ...commonBodyStyle }}
          headerStyle={{ ...commonHeaderStyle }}
        />
      ))}
      {actions && (
        <Column
          key="skel-actions"
          header={t('common.column_actions')}
          body={skeletonBody}
          bodyStyle={{ justifyContent: 'center', display: 'flex', ...commonBodyStyle }}
          headerStyle={{ justifyContent: 'center', display: 'flex', ...commonHeaderStyle }}
        />
      )}
    </DataTable>
  );
};

export default TableSkeletonLoader;
